// extracted by mini-css-extract-plugin
module.exports = {"todoTime":"style_todoTime__1L05-"};